<p-accordion [multiple]="true" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
  @for (tab of field.fieldGroup; track $index) {
    @if (!tab.hide) {
      <p-accordion-panel [value]="$index" [dt]="props.dt?.components?.accordion?.panel">
        <p-accordion-header [dt]="props.dt?.components?.accordion?.header">
          {{ tab.props.label }}
        </p-accordion-header>

        <p-accordion-content [dt]="props.dt?.components?.accordion?.content">
          <formly-field [field]="tab" />
        </p-accordion-content>
      </p-accordion-panel>
    }
  }
</p-accordion>

@if (!props.readonly && uploadMenu?.length) {
  <div class="row border-t-1 border-surface-border p-4">
    @if (uploadMenu.length > 1) {
      <new-ui-button
        [dt]="props.dt?.components?.button"
        icon="icon-[mi--document-file-upload-bottom-center]"
        severity="secondary"
        [label]="props.uploadLabel"
        (onClick)="menu.toggle($event)"
      />

      <p-menu #menu [popup]="true" [model]="uploadMenu" appendTo="body" />
    } @else {
      <new-ui-button
        [dt]="props.dt?.components?.button"
        icon="icon-[mi--document-file-upload-bottom-center]"
        severity="secondary"
        [label]="props.uploadLabel"
        (onClick)="openUploadDialog(props.uploadTypes[0])"
      />
    }
  </div>
}
